// extracted by mini-css-extract-plugin
export var active = "new-menu-module--active--db47b";
export var menuTabs = "new-menu-module--menu-tabs--52d53";
export var minPriceInfo = "new-menu-module--minPriceInfo--9c0d5";
export var minPriceInfoMobile = "new-menu-module--minPriceInfoMobile--981bd";
export var sectionMenu = "new-menu-module--section-menu--061c7";
export var sectionMenu__title = "new-menu-module--section-menu__title--1e591";
export var sectionMenu__wrapp = "new-menu-module--section-menu__wrapp--26404";
export var tab__body = "new-menu-module--tab__body--c0ead";
export var tab__chapter = "new-menu-module--tab__chapter--b8da0";
export var tab__chapterIcon = "new-menu-module--tab__chapterIcon--0379b";
export var tab__chapterIconWrapper = "new-menu-module--tab__chapterIconWrapper--32c82";
export var tab__chapterText = "new-menu-module--tab__chapterText--1ab3d";
export var tab__header = "new-menu-module--tab__header--08356";
export var tab__headerChapter = "new-menu-module--tab__header-chapter--4b692";
export var tabs_border = "new-menu-module--tabs_border--1a57c";